import {
  Observable,
  of,
  Subscriber,
} from 'rxjs';

import {
  Button,
  Column,
  Form,
} from '@rs-bank/rs-layout';

import { WizardDataStep } from '../../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-data-step';
import {
  ReferenceGroup,
  ReferenceGroupLanguage,
  ReferenceGroupLanguageName,
} from '../../references.entities';
import { ReferencesGroupWizardComponent } from '../references-group-wizard.component';

export class ReferenceFirstStep extends WizardDataStep<ReferencesGroupWizardComponent> {

	private readonly stepTitle = 'Язык справки';

	public override onInit(): Observable<void> {
		this.wizard.title = this.stepTitle;
		this.stepInformation.defaultButtonsHidden.next(true);

		return this.createLayout(this.wizardComponent.group);
	}

	public override onExecute(): Observable<void> {
		return of(undefined);
	}


	public override prepareBack(): Observable<void> {
		this.wizard.title = this.stepTitle;

		return super.prepareBack();
	}

	private createLayout(enquiryGroup: ReferenceGroup): Observable<void> {
		return new Observable((subscriber: Subscriber<void>) => {

			this.layoutForm = new Form(
				'Выберите язык справки',
				new Column(
					Object.keys(enquiryGroup.multilangReference!).map((key: ReferenceGroupLanguage) => {
						return new Button(
							ReferenceGroupLanguageName[key],
							() => {
								this.wizard.next(key)
							},
							of(false),
							{
cssClassList: [
'button-in-list',
'button-choose-lang',
`button-choose-lang--${key}`,
],
},
						)
					}),
				),
				undefined,
			);


			subscriber.next();
			subscriber.complete();
		})
	}

}